module.exports = __webpack_public_path__ + "media/icons/audio-wave-1b02b1f7.gif";